import { render } from "./SnehaSparshamIntro.vue?vue&type=template&id=033cb139&scoped=true"
import script from "./SnehaSparshamIntro.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamIntro.vue?vue&type=script&lang=js"

import "./SnehaSparshamIntro.vue?vue&type=style&index=0&id=033cb139&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033cb139"]])

export default __exports__